import { createStore } from '@stencil/store';
import { FlightDetailModalState } from 'types';
import { changeOverflowBody } from 'utils/ui';
import initParams from './initParams';

const { state, onChange, reset } = createStore<FlightDetailModalState>({
  departureFlights: undefined,
  returnFlights: undefined,
  airlines: [],
  activeTab: 'DEPARTURE',
  isOpen: false,
});

onChange('isOpen', newValue => {
  changeOverflowBody(newValue, initParams.isApp);
  if (!newValue) {
    state.returnFlights = undefined;
    state.departureFlights = undefined;
    state.activeTab = 'DEPARTURE';
    state.airlines = [];
  }
});

window.document.addEventListener('reset-chat-stores', () => {
  reset();
});

export default state;
